/* Copyright 2023 Sebastian Spautz

    This File is Part of "RPGSheetManager - Frl. Bernburgs Pensionat".

    "RPGSheetManager" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

import component from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/components/formControls.mjs'
import CollaborationControls from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/components/collaborationControls.mjs'
import * as formoperator from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/main.mjs'
import {} from '../../../node_modules/@sebastiansit/webcomponents/select-image/src/select-image.js'

document.addEventListener('DOMContentLoaded', (event) => {
  const viewModeParam = new URL(window.location.href).searchParams.get('viewmode')
  if (viewModeParam) {
    document.body.classList.add(viewModeParam)
  } else {
    document.body.classList.remove('read')
  }

  window.customElements.define('sit-formcontrols', component)
  window.customElements.define('sit-collaborationcontrols', CollaborationControls)

  // Collaboration Dialog
  const collaborationDialog = document.querySelector('dialog')
  if (collaborationDialog) {
    // Dialog öffnen
    const controlOpenDialog = document.getElementById('buttonCollaborationOpen')
    const onOpenDialog = (event) => {
      collaborationDialog.showModal()
    }
    controlOpenDialog.addEventListener('pointerup', onOpenDialog)
    controlOpenDialog.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        onOpenDialog(event)
      }
    })

    // Dialog schließen
    const controlCloseDialog = document.getElementById('control_closeDialog')
    const onCloseDialog = (event) => {
      collaborationDialog.close()
    }
    controlCloseDialog.addEventListener('pointerup', onCloseDialog)
    controlCloseDialog.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        onCloseDialog(event)
      }
    })
  }

  document.getElementById('ladies')?.addEventListener('change', (event) => {
    if (event.target.matches('[data-exportkey="name"]')) {
      event.target.closest('.arrayitem').getElementsByTagName('h3')[0].innerText = event.target.value
    }
  })

  formoperator.loadInitial()
    .then(() => {
      document.querySelectorAll('#ladies .arrayitem').forEach(lady => {
        lady.querySelector('h3').innerText = lady.querySelector('[data-exportkey="name"]').value
      })
    })
    .then(() => {
      if (viewModeParam) {
        formoperator.switchViewMode(document.getElementById('formCharacter') || document.getElementById('formPensionat'), viewModeParam)
      }
      initPWA()
    })
    .catch(() => {
      alert("Ein Fehler ist aufgetretten. Versuch doch bitte mal die Seite neu zu laden.")
    })
})

window.addEventListener('load', () => {
  if (typeof navigator.serviceWorker !== 'undefined') {
    navigator.serviceWorker.register('./serviceworker.js')
    .then(serviceWorkerRegistration => {
      serviceWorkerRegistration.addEventListener("updatefound", (event) => {
        console.log("Ein Update steht bereit!")
      });
    })
  }

  const collabButton = document.getElementById('buttonCollaborationOpen')
  const collabDialog = document.querySelector('dialog')

  if (collabButton) {
    window.addEventListener('offline', () => {
      collabButton.disabled = true
      collabDialog.close()
    })
    window.addEventListener('online', () => {
      collabButton.disabled = false
    })
  }
})

function initPWA() {
  let installPrompt = null
  const installButton = document.getElementById("installPWA")

  if (installButton) {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault()
      installPrompt = event
      installButton.removeAttribute("hidden")
    })
  
    installButton.addEventListener("click", async () => {
      if (installPrompt) {  
        const result = await installPrompt.prompt()
        console.log(`Install prompt was: ${result.outcome}`)
      }
      installPrompt = null
      installButton.setAttribute("hidden", "")
    })
  }
}
